module.exports = __webpack_public_path__ + "img/cs.23839707.jpg";